export const exportService = {
  async exportFinancePDF(params: {
    type?: 'daily' | 'monthly' | 'yearly' | 'range';
    date?: string;
    month?: string;
    year?: number;
    start_date?: string;
    end_date?: string;
    category?: string;
  }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params.type) queryParams.append('type', params.type);
    if (params.date) queryParams.append('date', params.date);
    if (params.month) queryParams.append('month', params.month);
    if (params.year) queryParams.append('year', params.year.toString());
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    if (params.category) queryParams.append('category', params.category);

    const token = localStorage.getItem('access_token');
    const response = await fetch(
      `${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/export/finance/pdf?${queryParams.toString()}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error('Failed to export PDF');
    }
    return await response.blob();
  },

  async exportFinanceExcel(params: {
    type?: 'daily' | 'monthly' | 'yearly' | 'range';
    date?: string;
    month?: string;
    year?: number;
    start_date?: string;
    end_date?: string;
    category?: string;
  }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params.type) queryParams.append('type', params.type);
    if (params.date) queryParams.append('date', params.date);
    if (params.month) queryParams.append('month', params.month);
    if (params.year) queryParams.append('year', params.year.toString());
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    if (params.category) queryParams.append('category', params.category);

    const token = localStorage.getItem('access_token');
    const response = await fetch(
      `${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/export/finance/excel?${queryParams.toString()}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error('Failed to export Excel');
    }
    return await response.blob();
  },

  async exportSalesPDF(params: {
    start_date?: string;
    end_date?: string;
    item_id?: number;
  }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    if (params.item_id) queryParams.append('item_id', params.item_id.toString());

    const token = localStorage.getItem('access_token');
    const response = await fetch(
      `${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/export/sales/pdf?${queryParams.toString()}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error('Failed to export PDF');
    }
    return await response.blob();
  },

  async exportSalesExcel(params: {
    start_date?: string;
    end_date?: string;
    item_id?: number;
  }): Promise<Blob> {
    const queryParams = new URLSearchParams();
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    if (params.item_id) queryParams.append('item_id', params.item_id.toString());

    const token = localStorage.getItem('access_token');
    const response = await fetch(
      `${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/export/sales/excel?${queryParams.toString()}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error('Failed to export Excel');
    }
    return await response.blob();
  },
};

